import React from 'react';
import { Breakpoints } from "@pb/utils/constants/breakpoints";
import { default as useMediaQuery } from "@pb/utils/reactHooks/useMediaQuery";
import cn from 'classnames';
import ScreenReaderOnlyText from '../../helpers/ScreenReaderOnlyText';
import { AliPayIcon, AmexIcon, DiscoverIcon, HMxKlarnaIcon, IdealIcon, JCBIcon, KlarnaIcon, MaestroIcon, MastercardIcon, MIRIcon, PayPalIcon, ApplePayMarkIcon, Przelewy24Icon, RuPayIcon, TroyIcon, VISAIcon, VippsIcon, BlikIcon, GooglePayIcon, MobilePayIcon, EmiIcon, UpiIcon, DinersClubIcon, CarnetIcon, SwishIcon, NetbankingIcon, WalletIcon, AfterpayIcon, } from '../../ui/Icon';
import styles from './PaymentList.module.scss';
const PaymentList = ({ paymentModes }) => {
    const isMobile = useMediaQuery(Breakpoints.SMALL);
    const size = isMobile ? 'small' : 'normal';
    const OPTION_ICON_MAP = {
        pay_later: React.createElement(HMxKlarnaIcon, { className: (styles.paymentIcon, styles.mobileIcon) }),
        pay_over_time: React.createElement(HMxKlarnaIcon, { className: styles.paymentIcon }),
        pay_in_parts: React.createElement(HMxKlarnaIcon, { className: styles.paymentIcon }),
        pay_now: React.createElement(KlarnaIcon, { className: styles.paymentIcon }),
        Klarna: React.createElement(KlarnaIcon, { className: styles.paymentIcon, size: size }),
        amex: React.createElement(AmexIcon, { className: styles.paymentIcon, size: size }),
        discover: React.createElement(DiscoverIcon, { className: styles.paymentIcon }),
        jcb: React.createElement(JCBIcon, { className: styles.paymentIcon }),
        'master-card': React.createElement(MastercardIcon, { className: styles.paymentIcon, size: size }),
        maestro: React.createElement(MaestroIcon, { className: styles.paymentIcon }),
        mir: React.createElement(MIRIcon, { className: styles.paymentIcon }),
        troy: React.createElement(TroyIcon, { className: styles.paymentIcon }),
        diners: React.createElement(DinersClubIcon, { className: styles.paymentIcon }),
        visa: React.createElement(VISAIcon, { className: styles.paymentIcon, size: size }),
        carnet: React.createElement(CarnetIcon, { className: styles.paymentIcon, size: size }),
        PayPal: React.createElement(PayPalIcon, { className: styles.paymentIcon, size: size }),
        applepay: React.createElement(ApplePayMarkIcon, { className: styles.paymentIcon, size: size }),
        mobilepay: React.createElement(MobilePayIcon, { className: styles.paymentIcon }),
        Alipay: React.createElement(AliPayIcon, { className: styles.paymentIcon }),
        AlipayDirect: React.createElement(AliPayIcon, { className: styles.paymentIcon }),
        '15': React.createElement(IdealIcon, { className: styles.paymentIcon }),
        BankTransfer: (React.createElement(React.Fragment, null,
            React.createElement(Przelewy24Icon, { className: cn(styles.paymentIcon, styles.multipleIcons) }),
            React.createElement(BlikIcon, { className: styles.paymentIcon, size: "small" }))),
        Rupay: (React.createElement(React.Fragment, null,
            React.createElement(EmiIcon, { className: cn(styles.paymentIcon, styles.multipleIcons) }),
            React.createElement(RuPayIcon, { className: cn(styles.paymentIcon, styles.multipleIcons) }),
            React.createElement(UpiIcon, { className: cn(styles.paymentIcon, styles.multipleIcons) }),
            React.createElement(DinersClubIcon, { className: styles.paymentIcon }))),
        razorpay: (React.createElement(React.Fragment, null,
            React.createElement(EmiIcon, { className: styles.paymentIcon }),
            ",",
            React.createElement(RuPayIcon, { className: styles.paymentIcon }),
            ",",
            React.createElement(UpiIcon, { className: styles.paymentIcon }),
            ",",
            React.createElement(NetbankingIcon, { className: styles.paymentIcon }),
            ",",
            React.createElement(WalletIcon, { className: styles.paymentIcon }))),
        razorpay_card: React.createElement(RuPayIcon, { className: styles.paymentIcon }),
        razorpay_cardless_emi: React.createElement(EmiIcon, { className: styles.paymentIcon }),
        razorpay_upi: React.createElement(UpiIcon, { className: styles.paymentIcon }),
        razorpay_netbanking: React.createElement(NetbankingIcon, { className: styles.paymentIcon, size: "small" }),
        razorpay_wallet: React.createElement(WalletIcon, { className: styles.paymentIcon, size: "small" }),
        vipps: React.createElement(VippsIcon, { className: styles.paymentIcon, size: "small" }),
        googlepay: (React.createElement(GooglePayIcon, { className: styles.paymentIcon, size: isMobile ? 'normal' : 'xlarge' })),
        Swish: React.createElement(SwishIcon, { className: styles.paymentIcon }),
        afterpay: React.createElement(AfterpayIcon, { className: styles.paymentIcon }),
    };
    if (!paymentModes) {
        return null;
    }
    const shouldShowOnlyText = ['COD'];
    const filteredPaymentsModes = paymentModes.filter((paymentMode) => {
        if (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.code) {
            return OPTION_ICON_MAP[paymentMode.code] || shouldShowOnlyText.includes(paymentMode.code);
        }
        return [];
    });
    return (React.createElement("ul", null, filteredPaymentsModes === null || filteredPaymentsModes === void 0 ? void 0 : filteredPaymentsModes.map((filterPaymentMode) => {
        return (filterPaymentMode === null || filterPaymentMode === void 0 ? void 0 : filterPaymentMode.code) ? (React.createElement("li", { className: cn(styles.payment), key: filterPaymentMode.code },
            OPTION_ICON_MAP[filterPaymentMode.code],
            shouldShowOnlyText.includes(filterPaymentMode.code) ? (filterPaymentMode.name) : (React.createElement(ScreenReaderOnlyText, null, filterPaymentMode.name)))) : null;
    })));
};
export default PaymentList;
//# sourceMappingURL=PaymentList.js.map